// Dependencies
import { h, Component } from 'preact';
import {connect} from 'react-redux'

// Components
import {Form, I18n, Row, Col, Container, Button} from 'components/elements'

// Helpers
import dayjs from 'lib/helpers/dayjs';
import { times } from 'lib/helpers';

// Actions
import {FilterActions} from 'actions'

// Styles
import style from './style.less'; 

// Class Component
@Form
@connect((state)=> state)
export default class AppointmentFilter extends Component { 
    // Constructor
	constructor(){
        super()
        this.handlePatientCount = this.handlePatientCount.bind(this)
        this.handleAppointmentType = this.handleAppointmentType.bind(this)
        this.handleDate = this.handleDate.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.setFilter = this.setFilter.bind(this)
        this.pleaseAddPatient = this.pleaseAddPatient.bind(this)
        this.filterSubmitSpinner = this.filterSubmitSpinner.bind(this)
	}

    // Hook Methods
    componentDidMount() {
        if(this.patientCount && this.patientCount.data && this.patientCount.data.length === 1){
            const initialValue = this.patientCount.data[0].value
            if(initialValue){
                this.handlePatientCount(initialValue)
            }
        }
    }

    
    // Methods
    handlePatientCount(patientCount){
        let _data = {patientCount}
        this.setFilter({..._data})
    }

    handleAppointmentType(appointmentTypeID){
        let _data = {appointmentTypeID}
        if(appointmentTypeID && !this.appointmentTypes.data.some((appType)=> appType.id == appointmentTypeID)){
            _data.appointmentTypeID = ''
        }
        this.setFilter({..._data})
    }

    handleDate(date){
        let _data = {}
        _data.startDate = dayjs(date).format()
        this.setFilter({..._data})
    }

    handleSubmit(formData){
        this.setFilter({...formData})
        this.props.onSubmit && this.props.onSubmit(formData)
    }

    setFilter(data){
        FilterActions.set({
            ...this.props.filters,
            ...data
        })
        this.props.onChange && this.props.onChange(data)
        this.setState({})
    }   

    filterSubmitSpinner(){
        return this.props.loading.organization || this.props.loading.patientData
    }

    pleaseAddPatient(){
        if(this.props.disabled && this.props.placeholderAppointment){
            return <I18n>pleaseAddAPatient</I18n>
        }
        return <I18n>go</I18n>
    }

    // Getters
    get appointmentTypes(){
        if(this.props.appointmentTypeFilters){
            let data = this.props.appointmentTypeFilters.data.map((appType)=>{
                appType.value = appType.id
                return appType
            })
            let initialValue = this.props.appointmentTypeFilters.initialValue
            let handler = this.props.appointmentTypeFilters.handler || (()=>{})
            let required = this.props.appointmentTypeFilters.required
            let span = this.props.appointmentTypeFilters.span
            return {data, initialValue, handler, required, span}
        }
    }

    get patientCount(){
        let appointmentTypes = Object.values(this.props.appointmentTypes) || []
        let maxPatients = 1
        appointmentTypes.forEach((appointmentType)=>{
            if(appointmentType.durations && appointmentType.durations.split(',').length > maxPatients){
                maxPatients = appointmentType.durations.split(',').length
            }
        })
        
        let patientType = 'Pet'
        if(this.props.config.genericPatients){
            patientType = 'Patient'
        }
        let data = [{name:`1 ${patientType}`,value:1}]
        data = data.concat(times(maxPatients - 1).map((i)=>{
            return {name:`${i + 2} ${patientType}s`,value:i + 2}
        }))
        if(this.props.PatientCountFilters){
            let initialValue = this.props.PatientCountFilters.initialValue
            let handler = this.props.PatientCountFilters.handler || (()=>{})
            let required = this.props.PatientCountFilters.required
            let span = this.props.PatientCountFilters.span
            return {data, initialValue, handler, required, span}
        }
    }

    get date(){
        if(this.props.dateFilters){
            let initialValue = this.props.dateFilters.initialValue
            let handler = this.props.dateFilters.handler || (()=>{})
            let required = this.props.dateFilters.required
            return {initialValue, handler, required}
        }
    }

    get session(){
        return this.props.session || {}
    }

    // Render Method
	render() {
        const {Form, SelectDark} = this.props;

		return (
            <Form onSubmit={this.handleSubmit} class={`${style.appointmentFilters} ${(this.session.resetPassword && style.faded) || ""}`}>
                <Container title='Appointment Filters' class={`${this.props.class || ""} ${style.containerView || ""}`}>
                    <Row class={style.appFilterRow}>
                        {this.patientCount && this.patientCount.data && this.patientCount.data.length > 1 &&
                            <Col span={{sm: 24}} class={style.appFilterCol}>  
                                <label className={style.labelInput}>
                                    {this.props.config.genericPatients ?
                                        I18n.t('numberOfPatients')
                                    :
                                        I18n.t('numberOfPets')        
                                    }
                                </label>          
                                <SelectDark 
                                    required={this.patientCount.required}
                                    data={this.patientCount.data} 
                                    initialValue={this.patientCount.initialValue} 
                                    name="patientCount" 
                                    placeholder={this.props.config.genericPatients ?
                                        I18n.t('numberOfPatients')
                                    :
                                        I18n.t('numberOfPets')        
                                    }
                                    onChange={this.handlePatientCount} />
                            </Col>
                        }
                        {this.appointmentTypes &&
                            <Col span={{sm: 24}} class={style.appFilterCol}>
                                <label className={style.labelInput}>{I18n.t("selectAnAppointmentType")}</label> 
                                <SelectDark 
                                    required={this.appointmentTypes.required}
                                    data={this.appointmentTypes.data} 
                                    initialValue={this.appointmentTypes.initialValue} 
                                    value={this.appointmentTypes.initialValue}
                                    name="appointmentTypeID" 
                                    placeholder={I18n.t("appointmentType")}
                                    onChange={this.handleAppointmentType}
                                />
                            </Col>
                        }
                    </Row>
                    <Row class={style.appFilterRow}>
                        {!this.props.hideSubmit && (
                                <Col span={{sm:24}} >
                                    <Button spinner={this.filterSubmitSpinner()} disabled={this.props.disabled ? true : false}>
                                        {this.pleaseAddPatient()}
                                    </Button>
                                </Col>
                            )
                        }
                    </Row>
                </Container>
            </Form>
		);
	}
}



// WEBPACK FOOTER //
// ./components/groups/AppointmentFilters/index.js